import React from 'react';
import { useParams } from 'react-router-dom';
import { withFullScreenWithSummaryBar } from '@bingads-webui-react/app-layout-container';
import { EditVideoPageComponent } from '@bingads-webui-campaign-react/ads-studio-app-components';

export const EditVideoPageImpl = (props) => {
  const { videoId } = useParams();

  return (<EditVideoPageComponent videoId={videoId} {...props} />);
};

export const EditVideoPage = withFullScreenWithSummaryBar(EditVideoPageImpl);
